import PropTypes from 'prop-types'
import { modNameChanger } from '../../../utils/utilities'
import UserBadges from '../../Utilities/UserBadges'
import UserInfoWidget from '../UserInfoWidget'

const UserName = ({
  message,
  user,
  expandedUserInfoWidget,
  setExpandedUserInfoWidget,
  modView
}) => {
  const handleOnClick = () =>
    modView
      ? null
      : setExpandedUserInfoWidget(
          expandedUserInfoWidget === message._id ? null : message._id
        )

  return (
    <>
      <div className="inline-flex gap-1 items-center mr-1 cursor-pointer">
        <span
          className={`text-${message.user.userService.profile.color} font-bold`}
          onClick={handleOnClick}
        >
          <UserBadges
            role={message.user.role.role}
            user={message.user}
            registrationDate={message.user.registrationDate}
          />
          {modNameChanger(message)}:
        </span>
      </div>
      {!modView && expandedUserInfoWidget === message._id && (
        <UserInfoWidget
          user={user}
          message={message}
          setExpandedUserInfoWidget={setExpandedUserInfoWidget}
        />
      )}
    </>
  )
}

UserName.propTypes = {
  message: PropTypes.object.isRequired,
  user: PropTypes.object,
  expandedUserInfoWidget: PropTypes.string,
  setExpandedUserInfoWidget: PropTypes.func,
  modView: PropTypes.bool
}

export default UserName
